import { useSelector } from "react-redux";
import { getCountry } from "@icarius-app/selectors";

// ej const isPeru = useIsCountry("PE");
const useIsSocietyCountry = (countryCode) => {
    const country = useSelector(getCountry);
    return country === countryCode;
};

export default useIsSocietyCountry;
